/** Prefix segments for TanStack Query — invalidate with partial keys, e.g. `{ queryKey: [CLEANER_PROPERTIES_QUERY_KEY] }`. */

import { isValidCleanerEntityId } from "@/lib/cleanerQueryGuards";

export const CLEANER_PROPERTIES_QUERY_KEY = "cleaner-properties" as const;
export const CLEANER_SECTIONS_QUERY_KEY = "cleaner-sections" as const;
export const CLEANER_TASKS_QUERY_KEY = "cleaner-tasks" as const;
export const CLEANER_CHECKLIST_QUERY_KEY = "cleaner-checklist" as const;

/** Stable segment when IDs are missing/invalid — avoids caching under keys that include "undefined". */
export const CLEANER_QUERY_DISABLED_SEGMENT = "__disabled__" as const;

export function cleanerPropertiesQueryKey(userId: string | undefined, orgId: string | undefined) {
  if (!isValidCleanerEntityId(userId) || !isValidCleanerEntityId(orgId)) {
    return [CLEANER_PROPERTIES_QUERY_KEY, CLEANER_QUERY_DISABLED_SEGMENT] as const;
  }
  return [CLEANER_PROPERTIES_QUERY_KEY, userId, orgId] as const;
}

export function cleanerSectionsQueryKey(propertyId: string | undefined, orgId: string | undefined) {
  if (!isValidCleanerEntityId(propertyId) || !isValidCleanerEntityId(orgId)) {
    return [CLEANER_SECTIONS_QUERY_KEY, CLEANER_QUERY_DISABLED_SEGMENT] as const;
  }
  return [CLEANER_SECTIONS_QUERY_KEY, propertyId, orgId] as const;
}

export function cleanerTasksQueryKey(
  propertyId: string | undefined,
  sectionId: string | undefined,
  orgId: string | undefined,
) {
  if (!isValidCleanerEntityId(propertyId) || !isValidCleanerEntityId(sectionId) || !isValidCleanerEntityId(orgId)) {
    return [CLEANER_TASKS_QUERY_KEY, CLEANER_QUERY_DISABLED_SEGMENT] as const;
  }
  return [CLEANER_TASKS_QUERY_KEY, propertyId, sectionId, orgId] as const;
}

/** Checklist rows for a section; fingerprint distinguishes task-id sets. */
export function cleanerChecklistQueryKey(sectionId: string | undefined, taskIds: string[]) {
  if (!isValidCleanerEntityId(sectionId)) {
    return [CLEANER_CHECKLIST_QUERY_KEY, CLEANER_QUERY_DISABLED_SEGMENT, ""] as const;
  }
  const fingerprint = [...taskIds].sort().join(",");
  return [CLEANER_CHECKLIST_QUERY_KEY, sectionId, fingerprint] as const;
}

export const CLEANER_LOCATION_ISSUE_HINTS_KEY = 'cleaner-location-issue-hints' as const;
export const CLEANER_LOCATION_INVENTORY_WARM_KEY = 'cleaner-location-inventory-warm' as const;

export function cleanerLocationIssueHintsQueryKey(locationId: string | undefined) {
  if (!isValidCleanerEntityId(locationId)) {
    return [CLEANER_LOCATION_ISSUE_HINTS_KEY, CLEANER_QUERY_DISABLED_SEGMENT] as const;
  }
  return [CLEANER_LOCATION_ISSUE_HINTS_KEY, locationId] as const;
}

export function cleanerLocationInventoryWarmQueryKey(locationId: string | undefined) {
  if (!isValidCleanerEntityId(locationId)) {
    return [CLEANER_LOCATION_INVENTORY_WARM_KEY, CLEANER_QUERY_DISABLED_SEGMENT] as const;
  }
  return [CLEANER_LOCATION_INVENTORY_WARM_KEY, locationId] as const;
}
